import React, { useContext } from 'react';
import { ComponentDependencyContext } from "./ComponentDependencyContext";
export var withComponentDependency = function withComponentDependency(BaseComponent) {
  var BaseComponentWithComponentDependency = function BaseComponentWithComponentDependency(baseProps) {
    var compDeps = useContext(ComponentDependencyContext);
    return /*#__PURE__*/React.createElement(BaseComponent, Object.assign({}, compDeps, baseProps));
  };
  BaseComponentWithComponentDependency.displayName = "withComponentDependency(".concat(BaseComponent.displayName || BaseComponent.name, ")");
  return BaseComponentWithComponentDependency;
};